export default __webpack_public_path__ + "static/media/img_step_car03.53354e42.jpg";